export class Movimentacao {
  constructor({
    uuid,
    ferramenta_uuid,
    created_at,
    deleted_at,
    documentos,
    observacao,
    status_anterior,
    status_atual,
    updated_at,
    user_id,
  }) {
    this.uuid = uuid;
    this.ferramenta_uuid = ferramenta_uuid;
    this.created_at = created_at;
    this.deleted_at = deleted_at;
    this.documentos = documentos;
    this.observacao = observacao;
    this.status_anterior = status_anterior;
    this.status_atual = status_atual;
    this.updated_at = updated_at;
    this.user_id = user_id;
  }
}
